import PropTypes from "prop-types";

import { currencyFormat } from "@lib/text.helpers";

import { BudgetCategoryView } from "../components";

import "./savings-budget.scss";

export const SavingsBudget = ({
  budgetCategoryCode,
  budgetPlan,
  isSelecting,
  onChoiceChange,
  selected,
}) => {
  const { taxInfo: { netIncome = 0 } = {} } = budgetPlan;

  return (
    <BudgetCategoryView
      className="savings-budget-view"
      budgetCategoryCode={budgetCategoryCode}
      getOptionAmount={(option) => option.amount}
      isSelecting={isSelecting}
      onChoiceChange={onChoiceChange}
      renderOptionContent={(option) =>
        `-${currencyFormat(option.amount * (netIncome / 12))}`
      }
      selected={selected}
    />
  );
};

SavingsBudget.propTypes = {
  budgetCategoryCode: PropTypes.string.isRequired,
  budgetPlan: PropTypes.shape({
    id: PropTypes.number,
    taxInfo: PropTypes.shape({
      netIncome: PropTypes.number,
    }),
  }),
  isSelecting: PropTypes.bool,
  onChoiceChange: PropTypes.func,
  selected: PropTypes.shape({
    id: PropTypes.number,
  }),
};
